import { Button, Flex, Input, message, Switch, Typography } from "antd";
import React from "react";
import { useUserFilesTabs } from "./UserFilesTabsContext";
import moment from "moment";
import { patchPostFetcher } from "../../../utils/fetcher";
import useSWRMutation from "swr/mutation";
import { mutate } from "swr";
import { useLocation } from "react-router-dom";
import { AppModal } from "../../../components/common";
type SessionReportForm = {
  mood: string;
  progress: string;
  notes: string;
  clientReportedIssues: string;
  emotionalState: string;
  behavioralObservations: string;
  redFlag: boolean;
  redFlagComment: string;
  keyDiscussionPoints: string;
  sessionProgress: string;
  selfReflections: string;
  referrals: string;
  nextSessionPlan: string;
};

type SessionReportPayload = {
  actionType: "session_report";
  formData: SessionReportForm;
};

export default function SessionReportModal({ sessionData }: any) {
  const { sessionReportModal, setSessionReportModal, selectedModalObjReport } =
    useUserFilesTabs();
  const { Text, Paragraph } = Typography;
  console.log(selectedModalObjReport, "sessionData");
  const [formData, setFormData] = React.useState<SessionReportForm>({
    mood: "",
    progress: "",
    notes: "",
    clientReportedIssues: "",
    emotionalState: "",
    behavioralObservations: "",
    redFlag: false,
    redFlagComment: "",
    keyDiscussionPoints: "",
    sessionProgress: "",
    selfReflections: "",
    referrals: "",
    nextSessionPlan: "",
  });

  console.log(formData, "formdata");

  React.useEffect(() => {
    if (sessionData) {
      setFormData({
        mood: selectedModalObjReport?.formData?.mood || "",
        progress: selectedModalObjReport?.formData?.progress || "",
        notes: selectedModalObjReport?.formData?.notes || "",
        clientReportedIssues:
          selectedModalObjReport?.formData?.clientReportedIssues || "",
        emotionalState: selectedModalObjReport?.formData?.emotionalState || "",
        behavioralObservations:
          selectedModalObjReport?.formData?.behavioralObservations || "",
        redFlag: selectedModalObjReport?.formData?.redFlag || false,
        redFlagComment: selectedModalObjReport?.formData?.redFlagComment || "",
        keyDiscussionPoints:
          selectedModalObjReport?.formData?.keyDiscussionPoints || "",
        sessionProgress: selectedModalObjReport?.formData?.sessionProgress || "",
        selfReflections: selectedModalObjReport?.formData?.selfReflections || "",
        referrals: selectedModalObjReport?.formData?.referrals || "",
        nextSessionPlan: selectedModalObjReport?.formData?.nextSessionPlan || "",
      });
    }
  }, [selectedModalObjReport]);

  const API_URL = process.env.REACT_APP_API_URL;

  const handleChange = <K extends keyof SessionReportForm>(
    key: K,
    value: SessionReportForm[K]
  ) => {
    setFormData((prev: SessionReportForm) => ({
      ...prev,
      [key]: value,
    }));
  };
  // const isFormFilled = Object.values(formData).some(
  //   (v) => v !== "" && v !== false
  // );
  // const isFormFilled =
  // !!formData &&
  // Object.values(formData || {}).some(
  //   (v) => v !== "" && v !== false
  // );
const isFormFilled =
  !!selectedModalObjReport?.formData &&
  Object.values(formData).some(
    (v) => v !== "" && v !== false && v != null
  );
  

  const { trigger: sessionReportTrigger, isMutating: sessionReportLoading } =
    useSWRMutation<any, any, string, SessionReportPayload>(
      isFormFilled
        ? `${API_URL}/sessionAction/action/${selectedModalObjReport?.actionId}`
        : `${API_URL}/sessionAction/session/${selectedModalObjReport?.sessionId}`,
      (url, { arg }) =>
        patchPostFetcher({
          url,
          data: arg,
          method: isFormFilled ? "PUT" : "POST",
        })
    );
    const location = useLocation();
    const clientId = location?.pathname.split("/")[3];

  const handleSave = async () => {
    const payload: SessionReportPayload = {
      actionType: "session_report",
      formData,
    };

    try {
      await sessionReportTrigger(payload);
       message.success(
      isFormFilled ? "Successfully updateds" : "Successfully created"
)
      mutate(
        `${API_URL}/session/sessionAction/byUserId/${clientId}/session_report`
      );
      setSessionReportModal(false);
    } catch (err) {
      console.error("Failed to save session report", err);
    }
  };

  const title = () => {
    return (
      <Flex justify="space-between" align="center">
        <Text className="font18">Session Report Form</Text>
        <Flex className="titleBtns" gap={8} justify="center" align="center">
          <Paragraph className="lastEdited">Last edited {moment(selectedModalObjReport?.updatedAt).format("DD/MM/YY hh:mm A")}</Paragraph>
          <Button
            type="default"
            className="saveBtn"
            onClick={handleSave}
            loading={sessionReportLoading}
          >
            Save
          </Button>
          <Button
            type="primary"
            className="discardBtn"
            onClick={() => setSessionReportModal(false)}
          >
            Discard
          </Button>
        </Flex>
      </Flex>
    );
  };
  

  return (
    <AppModal
      className="sessionReportModal"
      title={title()}
      open={sessionReportModal}
      onCancel={() => {
  setSessionReportModal(false);
  ;
}}
    >
      <Flex vertical gap={12} justify="center" className="sessionInfo">
        <Text className="header">Session Information</Text>
        <Flex gap={8} vertical className="userDetails">
  <Flex justify="space-between">
    <Text className="label">Client ID</Text>
    <Text className="value">
      {selectedModalObjReport?.clientId ?? "-"}
    </Text>
  </Flex>

  <Flex justify="space-between">
    <Text className="label">Session Number</Text>
    <Text className="value">
      {selectedModalObjReport?.sessionNumber ?? "-"}
    </Text>
  </Flex>

  <Flex justify="space-between">
    <Text className="label">Bookings Date</Text>
    <Text className="value">
      {selectedModalObjReport?.bookingDate 
        ? moment(selectedModalObjReport.bookingDate).format("DD MMM YYYY")
        : "-"}
    </Text>
  </Flex>

  <Flex justify="space-between">
    <Text className="label">Booking Time Slot</Text>
    <Text className="value">
      {selectedModalObjReport?.sessionDateTime
        ? moment(selectedModalObjReport.sessionDateTime).format("hh:mm A")
        : "-"}
    </Text>
  </Flex>

  <Flex justify="space-between">
    <Text className="label">Session Duration</Text>
    <Text className="value">
      {selectedModalObjReport?.sessionDuration
        ? `${selectedModalObjReport.sessionDuration} mins`
        : "-"}
    </Text>
  </Flex>

  <Flex justify="space-between">
    <Text className="label">Last Taken</Text>
    <Text className="value">
      {selectedModalObjReport?.lastTaken
        ? moment(selectedModalObjReport.lastTaken).format("DD MMM YYYY, hh:mm A")
        : "-"}
    </Text>
  </Flex>

  <Flex justify="space-between">
    <Text className="label">Counselor</Text>
    <Text className="value">
      {selectedModalObjReport?.counselor ?? "-"}
    </Text>
  </Flex>
</Flex>
      </Flex>
      <Flex vertical gap={16} className="presConcern">
        <Text className="header">Presenting Concerns</Text>
        <Flex vertical gap={8}>
          <Text className="label">Client’s Reported Issues</Text>
          <Input.TextArea
            className="textArea"
            placeholder="Summarize concerns shared by the client"
            rows={5}
            value={formData?.clientReportedIssues}
            onChange={(e) =>
              handleChange("clientReportedIssues", e.target.value)
            }
          />
        </Flex>
        <Flex vertical gap={8}>
          <Text className="label">Emotional State</Text>
          <Input.TextArea
            className="textArea"
            placeholder="Describe mood, affect, or emotional presentation"
            rows={5}
            value={formData?.emotionalState}
            onChange={(e) => handleChange("emotionalState", e.target.value)}
          />
        </Flex>
        <Flex vertical gap={8}>
          <Text className="label">Behavioral Observations</Text>
          <Input.TextArea
            className="textArea"
            placeholder="Tone and engagement level"
            rows={5}
            value={formData?.behavioralObservations}
            onChange={(e) =>
              handleChange("behavioralObservations", e.target.value)
            }
          />
        </Flex>
      </Flex>
      <Flex vertical gap={8} className="redFlag">
        <Flex gap={4} align="center">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.003 16H12.011M12.003 9.99997V13M10.578 5.21697L3.51998 17C3.37456 17.252 3.29765 17.5377 3.29688 17.8287C3.29612 18.1197 3.37153 18.4058 3.51562 18.6586C3.65972 18.9114 3.86747 19.1221 4.11823 19.2697C4.36899 19.4173 4.65402 19.4967 4.94498 19.5H19.061C19.3521 19.497 19.6373 19.4178 19.8882 19.2702C20.1391 19.1227 20.347 18.912 20.4912 18.6591C20.6353 18.4062 20.7107 18.1199 20.7098 17.8288C20.7089 17.5377 20.6317 17.252 20.486 17L13.429 5.21697C13.2805 4.9719 13.0714 4.76925 12.8218 4.6286C12.5722 4.48796 12.2905 4.41406 12.004 4.41406C11.7175 4.41406 11.4358 4.48796 11.1862 4.6286C10.9365 4.76925 10.7274 4.9719 10.579 5.21697"
              stroke="#F87A36"
              strokeWidth="2"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <Flex gap={8} align="center">
            <Text className="label">Redflag</Text>
            <Switch
              size="small"
              checked={formData?.redFlag}
              className="redFlagSwitch"
              onChange={(checked) => handleChange("redFlag", checked)}
            />
          </Flex>
        </Flex>
        <Input.TextArea
          className="textArea"
          placeholder="Comment"
          rows={5}
          value={formData?.redFlagComment}
          onChange={(e) => handleChange("redFlagComment", e.target.value)}
        />
      </Flex>
      <Flex vertical className="keyDiscussion" gap={16}>
        <Flex gap={8} vertical>
          <Text className="label">Key Discussion Points</Text>
          <Input.TextArea
            className="textArea"
            placeholder="Summarize main topics discussed"
            rows={5}
            value={formData?.keyDiscussionPoints}
            onChange={(e) =>
              handleChange("keyDiscussionPoints", e.target.value)
            }
          />
        </Flex>
        <Flex gap={8} vertical>
          <Text className="label">Progress in Session</Text>
          <Input.TextArea
            className="textArea"
            placeholder="Any progress, setbacks, changes in behavior"
            rows={5}
            value={formData?.sessionProgress}
            onChange={(e) => handleChange("sessionProgress", e.target.value)}
          />
        </Flex>
        <Flex gap={8} vertical>
          <Text className="label">Client’s Insights & Self-Reflections</Text>
          <Input.TextArea
            className="textArea"
            placeholder="New realizations or perspectives"
            rows={5}
            value={formData?.selfReflections}
            onChange={(e) => handleChange("selfReflections", e.target.value)}
          />
        </Flex>
      </Flex>
      <Flex vertical className="notePad" gap={16}>
        <Text className="header">Notepad</Text>
        <Flex gap={8} vertical>
          <Text className="label">Referrals (if any)</Text>
          <Input.TextArea
            className="textArea"
            placeholder="Psychiatrist, support group, etc."
            rows={5}
            value={formData?.referrals}
            onChange={(e) => handleChange("referrals", e.target.value)}
          />
        </Flex>
        <Flex gap={8} vertical>
          <Text className="label">Next Session Plan</Text>
          <Input.TextArea
            className="textArea"
            placeholder="Topics to explore, goals to focus on"
            rows={5}
            value={formData?.nextSessionPlan}
            onChange={(e) => handleChange("nextSessionPlan", e.target.value)}
          />
        </Flex>
      </Flex>
    </AppModal>
  );
}
